import { BreadcrumbService } from "@services/breadcrumb.service";
import { StateDeclaration, StateService, TransitionService } from "@uirouter/angularjs";
import * as angular from "angular";
//import * as rg4js from 'raygun4js';
import { PageStateNames } from "./class/PageStateNames";
import "./countWatchers";
import { BroadcastEvent } from "./enum/BroadcastEvent";
import { IRunBlockRootScope } from "./interfaces/IRunBlockRootScope";

//const worker = new Worker("worker.js", { type: 'module' } );

//worker.postMessage({ a: 1 });
//worker.onmessage = (event) => { console.log("main.onmessage", event); };

//worker.addEventListener("message", (event) => { console.log("main.message", event); });

export class RunBlock {

    static $inject = ["$rootScope", "$transitions", "$state", "breadcrumbService", "apiUrl", "isMobile", "isLocalDevelopment", "isFleet", "themeService", "themeServiceNew"];

    constructor(
        $rootScope: IRunBlockRootScope,
        $transitions: TransitionService,
        $state: StateService,
        breadcrumbService: BreadcrumbService,
        apiUrl: string,
        isMobile: boolean,
        isLocalDevelopment: boolean,
        isFleet: boolean) {

        $rootScope.apiUrl = apiUrl;
        $rootScope.isMobile = isMobile;

        //$trace.enable('TRANSITION');
        //console.warn("-- start");
        //console.log("$state", $state);
        //console.log("$transitions", $transitions);

        $rootScope.isLocalDevelopment = isLocalDevelopment;
        $rootScope.isDeployed = !isLocalDevelopment;
        $rootScope.isFleet = isFleet;

        //$http.defaults.cache = CacheFactory('defaultCache', {
        //    maxAge: 60 * 60 * 1000, // Items added to this cache expire after 60 minutes
        //    //cacheFlushInterval: 60 * 60 * 1000, // This cache will clear itself every hour
        //    deleteOnExpire: 'passive' // Items will be deleted from this cache when they expire
        //});

        $rootScope.$on("$stateChangeStart", (event, toState: StateDeclaration, toStateParams) => {
            if (toState.redirectTo && toState.redirectTo === $rootScope.toState.name) {
                event.preventDefault();
                return;
            }

            $rootScope.showToolbarLoadingIndicator = true;
            $rootScope.showPageLoader = true;

            if (toState && toState.name != PageStateNames.AUTHENTICATION_LOGIN) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
            }
        });

        //$rootScope.$on("$stateChangeError", (event, toState: StateDeclaration, toStateParams) => {
        //    console.log("$stateChangeError", event, toState, toStateParams);
        //});

        //$rootScope.$on("$stateChangeCancel", (event, toState: StateDeclaration, toStateParams) => {
        //    console.log("$stateChangeCancel");
        //});

        $transitions.onSuccess({}, transition => {

            var fromState = transition.from();
            var toState = transition.to();
            //});

            //$rootScope.$on("$stateChangeSuccess", (event, toState: StateDeclaration, toParams: StateDeclaration, fromState) => {

            $rootScope.$evalAsync(() => {
                $rootScope.showToolbarLoadingIndicator = false;
                $rootScope.showPageLoader = false;
            });

            // Save previous state for login redirection purposes
            if (!$state.current.data) {
                $state.current.data = {};
            }

            $state.current.data.previous = fromState;

            breadcrumbService.updateDocumentTitle();

            // raygun
            //rg4js('trackEvent', {
            //    type: 'pageView',
            //    path: window.location.pathname
            //});
        });

        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                $rootScope.$broadcast(BroadcastEvent.onPageVisibilityHide);
            }
            else {
                $rootScope.$broadcast(BroadcastEvent.onPageVisibilityShow);
            }
        });
    }

    //setNavigationState($scope: angular.IScope, $state: StateDeclaration, $stateParams: StateParams) {
    //    $scope.$navigationState = {
    //        currentState: $state.$current,
    //        params: $stateParams,
    //        getDisplayName: function (state) {

    //            if ($scope.hasCustomResolver) {
    //                return $scope.itemDisplayNameResolver({
    //                    defaultResolver: defaultResolver,
    //                    state: state,
    //                    isCurrent: isCurrent(state)
    //                });
    //            }
    //            else {
    //                return defaultResolver(state);
    //            }
    //        },
    //        isCurrent: function (state) {

    //            return isCurrent(state);
    //        }
    //    }
    //};
}

angular
    .module('exceptionOverride', [])
    //.factory('$exceptionHandler', function () {
    //    return function (exception, cause) {
    //        rg4js('send', { error: exception, customData: { cause: cause }, tags: ['Angular'] });
    //    };
    //});
